import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetItem  {
    _originalTypeClassName = "zERP.BO.BudgetItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetItem.translate = translateService;
}
this.Category = new Domain.BudgetItemCategory();
this.Children = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Level = null;
this.IsTermninal = false;
this.FullName = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Level:any;
IsTermninal:any;
FullName:any;
Category:any;
Children:any;
Parent:any;
static setCategory = ($this, value) => {
var oldValue = $this.Category;
$this.Category = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetItemCategory.removeItems(oldValue, $this);
}
Domain.BudgetItemCategory.addItems(value, $this);
}
}
static setChildren = ($this, items) => {
                if (items == null) items = [];
                if ($this.Children == null) $this.Children = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Children.length > 0) {
                    Domain.BudgetItem.removeChildren($this, $this.Children[0]);
                }

                Domain.BudgetItem.addManyChildren($this, copyItems);
            }
static addManyChildren = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetItem.addChildren($this, items[i]);
                }
            }
static addChildren = ($this, item) => {
                if ($this.Children == null) $this.Children = [];
                if (item == null || $this.Children.indexOf(item) > -1) return;
                $this.Children.push(item);
if (item.Parent != $this) {
Domain.BudgetItem.setParent(item, $this);
}
}
static addRangeChildren = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetItem.addChildren($this, item));
            }
static removeChildren = ($this, item) => {
                if ($this == null || $this.Children == null || $this.Children.indexOf(item) === -1) return;
                var _index = $this.Children.indexOf(item);
                $this.Children.splice(_index, 1);
item.Parent = null;
}
static clearChildren = ($this) => { $this.Children = null; }
static setParent = ($this, value) => {
var oldValue = $this.Parent;
$this.Parent = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetItem.removeChildren(oldValue, $this);
}
Domain.BudgetItem.addChildren(value, $this);
}
}

static GetClassName(): any{return "BudgetItem";
}
static GetFirstLevelParent($this: any): any{if (CLMS.Framework.Number.Equal(() => $this.Level, () => 1) || $this?.Parent == null) {return null;}
let parent = $this?.Parent;
let safetyCounter = 100;
while (CLMS.Framework.Number.GreaterThan(() => parent.Level, () => 1) && parent != null && CLMS.Framework.Number.GreaterThan(() => safetyCounter, () => 0)) {safetyCounter = Joove.Common.safeNumber(safetyCounter) - Joove.Common.safeNumber(1);parent = parent?.Parent;}
return parent;
}
static GetFullName($this: any): any{return $this?.Code + " - " + $this?.Name;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}